export const LANGUAGE_CODE = [
    {
        name: "Chinese",
        value: 0,
    },
    {
        name: "Cantonese",
        value: 1,
    },
    {
        name: "English",
        value: 2,
    },
    {
        name: "Spanish",
        value: 3,
    }
    ,
    {
        name: "French",
        value: 4,
    }
    ,
    {
        name: "German",
        value: 5,
    }
    ,
    {
        name: "Arabic",
        value: 6,
    }
    ,
    {
        name: "Russian",
        value: 7,
    }
    ,
    {
        name: "Portuguese",
        value: 8,
    }
    ,
    {
        name: "Italian",
        value: 9,
    }
    ,
    {
        name: "Japanese",
        value: 10,
    }
    ,
    {
        name: "Korean",
        value: 11,
    }
    ,
    {
        name: "Hindi",
        value: 12,
    }
    ,
    {
        name: "Bengali",
        value: 13,
    }
    ,
    {
        name: "Urdu",
        value: 14,
    }
    ,
    {
        name: "Nirerian Pidgin",
        value: 15,
    }
    ,
    {
        name: "Egypitan Arabic",
        value: 16,
    }
    ,
    {
        name: "Marathi",
        value: 17,
    }
    ,
    {
        name: "Telugu",
        value: 18,
    }
    ,
    {
        name: "Tamil",
        value: 19,
    }
    ,
    {
        name: "Vietnamese",
        value: 20,
    }
    ,
    {
        name: "Tagalog",
        value: 21,
    }
    ,
    {
        name: "Polish",
        value: 22,
    }
    ,
    {
        name: "Ukrainian",
        value: 23,
    }
    ,
    {
        name: "Malayalam",
        value: 24,
    }
    ,
    {
        name: "Romanian",
        value: 25,
    }
    ,
    {
        name: "Thai",
        value: 26,
    }
    ,
    {
        name: "Dutch",
        value: 27,
    }
    ,
    {
        name: "Indoonesian",
        value: 28,
    }
    ,
    {
        name: "Nepali",
        value: 29,
    }
    ,
    {
        name: "Hungarian",
        value: 30,
    }
    ,
    {
        name: "Czech",
        value: 31,
    }
    ,
    {
        name: "Rwanda",
        value: 32,
    }
    ,
    {
        name: "Swedish",
        value: 33,
    }
    ,
    {
        name: "Hiligaynon",
        value: 34,
    }
    ,
    {
        name: "Greek",
        value: 35,
    }
    ,
    {
        name: "Haryanvi",
        value: 36,
    }
    ,
    {
        name: "Marwari",
        value: 37,
    }
    ,
    {
        name: "Madura",
        value: 38,
    }
    ,
    {
        name: "Burmese",
        value: 39,
    }
]